module.exports = __webpack_public_path__ + "img/youth-driveway-01.009c772c.jpg";